export default __webpack_public_path__ + "static/media/iconRobot.8a5e3fb1.svg";